import React from 'react';
import { motion } from 'framer-motion';
import { Compass, BookOpen, Map, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
const features = [{
  title: 'Career Journeys',
  description: 'My professional path and milestones.',
  icon: Compass,
  color: 'text-blue-500',
  bg: 'bg-blue-50',
  link: '/career-journeys'
}, {
  title: 'Thoughts',
  description: 'Musings on design and life.',
  icon: BookOpen,
  color: 'text-purple-500',
  bg: 'bg-purple-50',
  link: '/thoughts'
}, {
  title: 'Travel Stories',
  description: 'Places that shaped my perspective.',
  icon: Map,
  color: 'text-green-500',
  bg: 'bg-green-50',
  link: '/travel-stories'
}, {
  title: 'Safe Space',
  description: 'A collection of comforting things.',
  icon: Heart,
  color: 'text-rose-500',
  bg: 'bg-rose-50',
  link: '/safe-space'
}];
export function FeaturesGrid() {
  return <section id="journey" className="py-24 px-6 bg-white" data-id="element-26">
      <div className="max-w-7xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-28">
          <h2 className="text-5xl font-moon-dance text-zen-text mb-4" data-id="element-29">
            Curated Collections
          </h2>
          <p className="text-zen-text/60 max-w-2xl mx-auto" data-id="element-30">
            Explore the different facets of my world, from professional
            endeavors to personal reflections.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-31">
          {features.map((feature, index) => <Link to={feature.link} key={feature.title} data-id="element-32">
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -10
          }} className="group relative p-8 rounded-2xl bg-zen-bg border border-zen-text/5 hover:shadow-xl transition-all duration-300 overflow-hidden h-full" data-id="element-33">
                <div className={`absolute top-0 right-0 w-32 h-32 ${feature.bg} rounded-bl-full opacity-50 transition-transform group-hover:scale-110`} data-id="element-34" />

                <div className={`w-12 h-12 rounded-xl ${feature.bg} flex items-center justify-center mb-6`} data-id="element-35">
                  <feature.icon className={`w-6 h-6 ${feature.color}`} data-id="element-36" />
                </div>

                <h3 className="text-2xl font-moon-dance text-zen-text mb-3" data-id="element-37">
                  {feature.title}
                </h3>
                <p className="text-zen-text/60 leading-relaxed" data-id="element-38">
                  {feature.description}
                </p>

                <div className="mt-6 flex items-center text-sm font-medium text-zen-text/40 group-hover:text-zen-accent transition-colors" data-id="element-39">
                  <span data-id="element-40">Explore</span>
                  <motion.span className="ml-2" initial={{
                x: 0
              }} whileHover={{
                x: 5
              }} data-id="element-41">
                    →
                  </motion.span>
                </div>
              </motion.div>
            </Link>)}
        </div>
      </div>
    </section>;
}